module.exports = "mutation UpdateCustomerFlagOrder($customers:[UpdateCustomerFlagOrderInput]!){updateCustomerFlagOrder(customers:$customers){success}}"